import {Navigate} from 'react-router-dom';
import {useSelector} from 'react-redux';

const ProtectedRoute = ({children, requiredRole}) => {
    const {user} = useSelector(state => state.user);

    if (!user) {
        return <Navigate to="/login" replace/>;
    }

    if (requiredRole && user.role?.roleName !== requiredRole) {
        return <Navigate to="/dashboard" replace/>;
    }

    return children;
};

export default ProtectedRoute;